import * as moment from 'moment';
import Constants from '../../globals/Constants';
import subscriptionStates from '../../types/SubscriptionStates';
import EntitlementStatusModel from '../../types/EntitlementStatusModel';
import {Moment} from 'moment';

const getUsersSubscriptionState = (entitlement: EntitlementStatusModel): string => {
   if (!entitlement || !entitlement.level || !entitlement.status) {
      return subscriptionStates.unknown;
   }

   const isSubscribed = entitlement.level.toLowerCase() === Constants.entitlements.levels.full.toLowerCase();
   const activeSub = isSubscribed && !isExpired(entitlement.expirationDate);

   return activeSub ? subscriptionStates.active : subscriptionStates.inactive;
};

const isExpired = (expirationDate: Moment): boolean => {
   const currentDateTimeInUtc = moment().utc();
   const expirationDateTimeInUtc = moment.utc(expirationDate);
   return currentDateTimeInUtc.isSameOrAfter(expirationDateTimeInUtc);
};

export default {getUsersSubscriptionState, isExpired};
